import React from "react";

/**
 * DotsPattern — motif de points répétés utilisé en texture d'arrière-plan.
 * Discret (opacity 5-10%), donne du grain sans surcharger.
 */
export function DotsPattern({
  color = "#00C6CE",
  size = 220,
  position = "top-0 right-0",
  opacity = 0.12,
  className = "",
}) {
  return (
    <div
      aria-hidden="true"
      className={`absolute pointer-events-none ${position} ${className}`}
      style={{ width: size, height: size, opacity, zIndex: 0 }}
    >
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <defs>
          <pattern id="dot-pattern" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1.6" fill={color} />
          </pattern>
        </defs>
        <rect width="200" height="200" fill="url(#dot-pattern)" />
      </svg>
    </div>
  );
}
